import { getDomain } from '@utils/judgeDomain';

const DESIGN_WIDTH = 375;

/**
 * 将设计稿 px 值转为 vw 字符串，用于 JS 中动态设置样式
 * @param px 设计稿中的 px 值
 * @returns vw 字符串，如 pxToVw(16) => '4.26667vw'
 */
export const pxToVw = (px: number): string => {
  return `${((px / DESIGN_WIDTH) * 100).toFixed(5)}vw`;
};

/**
 * @description: 获取img完整地址
 * @event: getImgUrl
 * @param: img 图片pid
 */
export const getImgUrl = (
  img?: string,
  isResize: boolean = false,
  size: number = 300,
  isQuality: boolean = false,
  format: string = 'webp',
): string => {
  if (!img) return '';
  if (img.indexOf('https://') > -1) return img;
  const pre = getDomain();
  let url = `https://oss-image${pre}/${img}?x-oss-process=image/format,${format}`;
  if (isResize) {
    url = url + `/resize,m_fill,h_${size},w_${size}`;
  }
  if (isQuality) {
    url = url + '/quality,Q_70';
  }
  return url;
};
